<template>
  <el-container>
    <el-form ref="form"
             :model="form"
             label-position="top"
             label-width="120px"
             @submit.native.prevent="forgetpassword">
      <el-form-item class="logo">
        <!--
        <img src="https://author.businessexpertpress.com/sites/bep_logo.png">
        <img src="https://author.businessexpertpress.com/sites/mp_logo.png">
        -->
        <h2>Request Password Reset</h2> 
      </el-form-item>
      <el-form-item style="height:25px">
        Email
        <el-input v-model="form.email" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item style="height:50px">
        <img :src="imageRandom" id="codeImage">
        <!--        
        :onload="delImageRandom()"
-->
      </el-form-item>
      <el-form-item style="height:25px">
        Please type the code
        <el-input v-model="userInputCode" style="width:200px"></el-input>
        <el-checkbox v-if="false" v-model="form.notrobot">I am not a robot</el-checkbox>
      </el-form-item>
     <el-form-item>
        <el-button v-if="timeforget == 1" type="primary"
                   native-type="submit">Email password reminder</el-button>
      </el-form-item>
    </el-form>
    <el-input v-if="timeforget < 0" v-model="timeforget"></el-input>
  </el-container>
</template>

<script>
export default {
  created(){
    this.axios({
      method: 'get',
      url: '/file/genrandomimage',
    }).then(res => {
      this.imageRandom = res.data.url;
      this.verifyCode = res.data.verifyCode;
console.log(this.verifyCode);
    });
    window.addEventListener("load", event => {
      // var image = document.getElementById('codeImage');
      // console.log(image.complete && image.naturalHeight !== 0);
      this.waitImageLoad();
    });
  },
  data() {
    return {
      form: {
        email: '',
        notrobot: true
      },
      imageRandom : '',
      verifyCode : '',
      userInputCode : '',
      //sharedArrayBuffer_for_sleep : '',
      //sharedArray_for_sleep : '',
      
      timeforget : 1
    };
  },
  methods: {
    waitImageLoad(){
      var image = document.getElementById('codeImage');
      console.log('wait');
      if((image.complete && image.naturalHeight !== 0)){
console.log('stop wait');
        this.delImageRandom();
        return;
      }
      window.setTimeout(this.waitImageLoad, 2111);
    },
    delImageRandom(){
console.log('begin delete');
console.log(this.verifyCode);
      this.axios({
        method: 'get',
        url: '/file/delrandomimage?c=' + this.verifyCode,
      })
    },
    forgetpassword(){
      if(! this.form.notrobot
        || this.verifyCode != this.userInputCode
////       || ! this.form.email
      ){
        return;
      }
      this.$confirm(
        'Do you forget your password and wish the system send a reset email to you?',
        'Info',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning',
        }
      )
      .then(() => {
        this.timeforget++;
        this.axios({
          method: 'post',
          url: '/forgetpassword',
          data: this.form,
        })
        .then(res => {
            this.$message({
              message: 'Mail sended, please check your mailbox!',
              type: 'success',
            });

        })
        .catch(err => {
            this.$message({
              message: 'Invalid email, or you clicked too often.',
              type: 'error',
            });
          
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: 'Sending mail canceled.',
          });

      })

    },
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-form {
    .el-form-item.logo {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 150px;
      }
    }
    .el-form-item {
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgetPassword.vue